<template>
	<v-app v-scroll.self="onScroll">
		<!-- <v-toolbar
			id="toolbar"
			:flat="!showMiniFilterLabel"
			:height="!showMiniFilterLabel? '150px': '80px'"
		>
			<v-row
				align="center"
				justify="center"
			>
				<v-col
					cols="12"
				>
					<v-row
						align="center"
						justify="center"
					>
						<n-link
							to="/"
							tag="span"
							style="cursor: pointer"
						>
							<img
								id="logo"
								src="images/RED_LOGO.TB.CO.TH.png"
								:height="!showMiniFilterLabel? '120px': '50px'"
								style="margin-top: 10px;"
							>
						</n-link>

						<n-link
							v-for="(item, i) in menuItems"
							:key="item.title"
							:to="item.to"
							:title="item.title"
							class="h1 text-header text-red no-underline d-none d-md-block"
							:class="{active: i==6}"
						>
							{{ item.title }}
						</n-link>
						<v-app-bar-nav-icon
							id="icon-drawer"
							class="d-md-none"
							style=""
							@click.stop="sidebar = !sidebar"
						/>
					</v-row>
				</v-col>
			</v-row>
		</v-toolbar> -->

		<client-only>
			<!-- Appbar mobile -->
			<v-app-bar
				v-if="isMobile"
				app
				:elevation="0"
			>
				<n-link
					:to="{ name: 'index' }"
					title="หน้าหลัก"
				>
					<img
						src="/images/LOGO.TB.CO.TH.png"
						alt=""
						class="logo d-inline-block"
					>
				</n-link>
				<v-spacer />
				<client-only>
					<div class="d-inline-block iconSearch sectionBorder">
						<fullSearchFormMobile
							ref="mobileSearchComponent"
							:params="$route.query"
						/>
					</div>
				</client-only>
				<div class="favorite">
					<favoriteProps />
				</div>
				<v-app-bar-nav-icon
					color="white"
					@click.stop="sidebar = !sidebar"
				/>
			</v-app-bar>

			<!-- Appbar desktop -->
			<v-app-bar
				v-else
				app
				:elevation="0"
			>
				<v-container>
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row>
								<v-col
									cols="4"
									md="1"
									xl="1"
								>
									<n-link
										:to="{ name: 'index' }"
										title="หน้าหลัก"
									>
										<img
											src="/images/LOGO.TB.CO.TH.png"
											alt=""
											class="logo d-inline-block"
										>
									</n-link>
								</v-col>
								<v-col
									class="text-center d-none d-md-block"
									md="10"
									xl="10"
								>
									<nav>
										<ul class="nav">
											<li>
												<n-link
													to="/"
													title="หน้าหลัก"
												>
													หน้าหลัก
												</n-link>
											</li>
											<li>
												<n-link
													to="/search?tx=BUY&market=REST"
													title="ขาย"
												>
													ขาย
												</n-link>
											</li>
											<li>
												<n-link
													to="/search?tx=RENT&market=REST"
													title="เช่า"
												>
													เช่า
												</n-link>
											</li>
											<!-- <li>
												<n-link
													to="/map-search"
													title="ค้นหา (แผนที่)"
													:event="$route.path === '/map-search' ? '' : 'click'"
												>
													ค้นหา (แผนที่)
												</n-link>
											</li> -->
											<!-- <li>
												<n-link
													to="/promotion"
													title="โปรโมชั่น 5 คุ้ม"
												>
													โปรโมชั่น 5 คุ้ม
												</n-link>
											</li> -->
											<li>
												<n-link
													to="/agent"
													title="ตัวแทน"
												>
													ค้นหาตัวแทน
												</n-link>
											</li>
											<li>
												<n-link
													:to="{name: 'service'}"
													title="บริการของเรา"
												>
													บริการของเรา
												</n-link>
											</li>
											<li>
												<n-link
													to="/portfolio"
													title="ผลงานของเรา"
												>
													ผลงานของเรา
												</n-link>
											</li>
											<li>
												<v-menu
													content-class="sub-menu-header"
													offset-y
												>
													<template #activator="{ attrs, on }">
														<a
															title="บทความ"
															v-bind="attrs"
															v-on="on"
														>
															บทความ
														</a>
													</template>

													<v-list>
														<v-list-item link>
															<n-link
																to="/blog/review"
																title="รีวิว"
															>
																รีวิว
															</n-link>
														</v-list-item>
														<v-list-item link>
															<n-link
																to="/blog/tips"
																title="สาระน่ารู้"
															>
																สาระน่ารู้
															</n-link>
														</v-list-item>
													</v-list>
												</v-menu>
											</li>
										</ul>
									</nav>
								</v-col>
								<v-col
									cols="8"
									md="1"
									xl="1"
									class="d-flex justify-end align-center"
								>
									<div class="d-inline-block favorite">
										<favoriteProps />
									</div>
									<div class="d-inline-block d-md-none">
										<v-app-bar-nav-icon
											@click.stop="sidebar = !sidebar"
										/>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</v-app-bar>
		</client-only>

		<v-navigation-drawer
			v-model="sidebar"
			:mini-variant="miniVariant"
			disable-resize-watcher
			app
			right
			temporary
			style="z-index: 99999;"
		>
			<v-layout
				column
				fill-height
			>
				<v-list class="sideMenu mt-2">
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							to="/"
						>
							หน้าหลัก
						</v-btn>
						<v-divider />
					</v-list-item>
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							exact
							class="justify-start"
							to="/search?tx=BUY&market=REST"
						>
							ขาย
						</v-btn>
						<v-divider />
					</v-list-item>
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							exact
							class="justify-start"
							to="/search?tx=RENT&market=REST"
						>
							เช่า
						</v-btn>
						<v-divider />
					</v-list-item>
					<!-- <v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							to="/map-search"
						>
							ค้นหา (แผนที่)
						</v-btn>
						<v-divider />
					</v-list-item> -->
					<!-- <v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							to="/promotion"
						>
							โปรโมชั่น 5 คุ้ม
						</v-btn>
						<v-divider />
					</v-list-item> -->
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							to="/agent"
						>
							ค้นหาตัวแทน
						</v-btn>
						<v-divider />
					</v-list-item>
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							:to="{name: 'service'}"
						>
							บริการของเรา
						</v-btn>
						<v-divider />
					</v-list-item>
					<v-list-item
						class="d-block"
						dense
					>
						<v-btn
							text
							href
							block
							class="justify-start"
							:to="{name: 'portfolio'}"
						>
							ผลงานของเรา
						</v-btn>
						<v-divider />
					</v-list-item>
					<v-list-item
						class="d-block"
						dense
					>
						<v-list-group>
							<template v-slot:activator>
								<v-list-item-content>บทความ</v-list-item-content>
							</template>
							<v-list-item dense>
								<v-btn
									to="/blog/review"
									title="รีวิว"
									exact
									text
									href
									block
									class="justify-start"
								>
									รีวิว
								</v-btn>
							</v-list-item>
							<v-list-item dense>
								<v-btn
									to="/blog/tips"
									title="สาระน่ารู้"
									exact
									text
									href
									block
									class="justify-start"
								>
									สาระน่ารู้
								</v-btn>
							</v-list-item>
						</v-list-group>
						<v-divider />
					</v-list-item>
				</v-list>
				<v-spacer />
				<div class="social bgDark">
					<a
						href="https://www.facebook.com/thebestpropertyhome"
						title="ติดตาม The Best Property  บนเฟสบุ๊ค"
						target="_blank"
					>
						<img
							src="/images/icon/facebook.png"
							alt=""
						>
					</a>
					<a
						href="https://m.me/thebestpropertyhome"
						title="สนทนากับ The Best Property"
						target="_blank"
					>
						<img
							src="/images/icon/messenger.png"
							alt=""
						>
					</a>
					<a
						href="https://line.me/ti/p/@thebestproperty"
						title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
						target="_blank"
					>
						<img
							src="/images/icon/line.png"
							alt=""
						>
					</a>
				</div>
			</v-layout>
		</v-navigation-drawer>

		<!-- Appbar -->

		<!-- Layout -->
		<!-- :class="isMobile ? 'mobile' : '' + showExtendfilter ? 'hasFilter' : ''" -->
		<nuxt
			keep-alive
			:keep-alive-props="{ include: keepAlivePages }"
			style="margin-top: 135px"
		/>

		<client-only>
			<cookie-law
				theme="blood-orange"
				button-text="ยอมรับ"
				message="เว็บไซต์ของ THE BEST PROPERTY AGENT ใช้คุกกี้เพื่อให้เว็บไซต์ทำงานได้อย่างถูกต้อง และช่วยปรับปรุงประสบการณ์การใช้งานของคุณเท่านั้น เราไม่ใช้คุกกี้เพื่อเก็บข้อมูลส่วนบุคคล หรือเพื่อติดตามการใช้งานของคุณในเชิงโฆษณา การกดปุ่ม “ยอมรับ” หมายถึงคุณยอมรับการใช้งานคุกกี้พื้นฐานที่จำเป็นต่อการทำงานของเว็บไซต์เท่านั้น"
			/>
		</client-only>
	</v-app>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'

import favoriteProps from '~/components/favorite-props'
import fullSearchFormMobile from '~/components/full-search-form-mobile'

export default {
	components: {
		favoriteProps,
		fullSearchFormMobile,
		CookieLaw: () => process.client ? import('vue-cookie-law') : null
	},

	data() {
		return {
			drawer: false,
			miniVariant: false,
			invertedScroll: true,
			showMiniFilterLabel: false,
			keepAlivePages: [
				'INDEX',
				'LIST',
				'MAP',
				'AGENT',
				'SERVICE'
			],
			appTitle: 'Awesome App',
			sidebar: false,
			menuItems: [
				{ title:'หน้าหลัก', to: '/'},
				{ title:'ขาย', to:'/search?tx=BUY&market=REST' },
				{ title:'เช่า', to:'/search?tx=RENT&market=REST' },
				// { title:'ค้นหา (แผนที่)', to:'/map-search' },
				// { title:'โปรโมชั่น 5 คุ้ม', to:'/promotion' },
				{ title:'ค้นหาตัวแทน', to:'/agent'},
				{ title:'บริการของเรา', to:{name: 'service'} },
				{ title:'ผลงานของเรา', to:{name: 'portfolio'} }
			]
		}
	},

	computed: {
		...mapGetters(['isMobile', 'hasFooter', 'latestUpdated', 'newProps']),
	},

	watch: {

	},

	created() {
		if (process.client) {
			// Inspect user device for first access
			this.deviceInspect()
		}
	},
	mounted(){
		window.windowNavigate = false
		window.addEventListener('popstate', this.backHandler, false) //backbutton
		window.addEventListener('scroll', this.onScroll)
		window.addEventListener('resize', this.onResize)

		setTimeout(() => {
			this.onScroll()
			this.onResize()
		}, 600);

		// setTimeout(() => {
		// 	this.showMiniFilterLabel = window.scrollY > 100
		// },700);
	},

	beforeDestroy () {
		window.removeEventListener('popstate', this.backHandler) //backbutton
		window.removeEventListener('scroll', this.onScroll)
		window.removeEventListener('resize', this.onResize)
	},

	methods: {
		...mapMutations({
			deviceInspect: 'deviceInspect'
		}),

		backHandler () {
			window.windowNavigate = true
		},

		onScroll () {
			if (window.scrollY > 100) {
				this.showMiniFilterLabel = true
			} else {
				this.showMiniFilterLabel = false
			}
		},

		onResize (){
			document.querySelectorAll('[data-ratio]').forEach(row=>{
				let ratio = eval(row.getAttribute('data-ratio'))
				let width = row.offsetWidth
				let height = width * ratio
				row.style.height = height +'px'
			})
		}

	}
}
</script>

<style lang="scss" scoped>
	#toolbar{
		height: 200px;
		position: fixed;
		z-index: 999;
		width: 100%;
		transition: all .1s;
	}
	#logo{
		transition: all .2s linear;
		margin-left: clamp(20px, 2vw, 120px);
		margin-right: clamp(20px, 2vw, 120px);
	}
	#icon-drawer{
		position: absolute !important;
		right: 26px;
		padding: 10px;
		font-size: 5vw;
		color: white;
		background: #f00;
		border-radius: 0px;
		transition: all .2s linear;
	}
	.tahoma{
		font-family: Tahoma;
	}
	.text-header{
		font-family: NotoSansThaiMedium;
	}
	.text-red{
		color: #e01f27;
	}
	.text-white{
		color: white;
	}
	.no-underline{
		text-decoration: none;
	}
  .footer i { color: #fff; font-size: 16px; }
  .sideMenu::v-deep {
		.v-list-group__header {
			min-height: 40px;
			font-size: 0.875rem;
		}
    a { text-decoration: none; color: #000; margin: 1px 0 2px 0; }
	}
	.v-navigation-drawer {
		.v-divider {
			flex: 1 0 100% !important;
		}

		.social {
			text-align: center;
			padding: 10px 0;

			a {
				margin-right: 5px;
			}
			img {
				height: 50px;
			}
		}
	}
	.search {
		background: transparent;
		border-radius: 0;
		padding: 0;
	}
	.miniFilter::v-deep {
		> .v-toolbar__extension {
			padding: 4px;

			> .inputSelect > div:not(:last-child) {
				max-width: 30%;
			}
		}
	}
	.sub-menu-header {
		box-shadow: unset;
		.v-list.v-sheet {
			background-color: #c20000;

			a {
				text-decoration: none;
				color: #fff;
			}
		}
	}
	// header{
	// 	color: #000000 !important;
	// 	background: rgba(255,255,255,0.9) !important;
	// }
	// header a{
	// 	color: #ec1c24;
	// 	font-size: clamp(13px, 4vw, 24px);
	// 	font-weight: 900;
	// 	margin-left: clamp(5px, 2vw, 10px);
	// 	margin-right: clamp(5px, 2vw, 10px);
	// }
	// header .active{
	// 	text-decoration: underline;
	// 	-moz-text-decoration: underline 4px;
	// 	-o-text-decoration: underline 4px;
	// }
</style>
